import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { mergeMap, first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { AuthenticationService } from 'src/app/_services/authentication.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) {}

  intercept(
    request: HttpRequest<any>,
    nextHttpHandler: HttpHandler
  ): Observable<HttpEvent<any>> {
    return this.authenticationService.jsonWebToken$.pipe(
      first(),
      mergeMap(jsonWebToken => {
        if (!jsonWebToken) {
          return nextHttpHandler.handle(request);
        }
        // add authorization header with jwt token if available
        return nextHttpHandler.handle(
          request.clone({
            setHeaders: {
              Authorization: `Bearer ${jsonWebToken}`
            }
          })
        );
      })
    ) as Observable<HttpEvent<any>>;
  }
}
